
// todo: split to constant.js

export const PAYMENT_METHOD = {
    ALIPAY: 'alipay.qrcode',
    WECHAT_PAY: 'wechat.qrcode',
    CREDIT_CARD: 'creditcard'
}

export const isCreditCardOnly = () => {
    return false;
};

export const isPaymentMethodEnable = (code) => {
    if (code == PAYMENT_METHOD.ALIPAY) {
        return false;
    } else if (code == PAYMENT_METHOD.WECHAT_PAY) {
        return true;
    }  else if (code == PAYMENT_METHOD.CREDIT_CARD) {
        return true;
    } 
    return false;
}

